export const TOTALS_KEY = "Totals"

export const DEFAULT_HEADERS = {
  CATEGORY: "Category",
  STATISTIC: "Statistic",
  VALUE: "Value",
  VALUES: "Values",
} as const

export const DEFAULT_CHART_LABELS = {
  CATEGORIES: "Categories",
  AVERAGE: "Average",
  VALUE: "Value",
} as const